import request from 'api/requestUtils'
import type { definitions } from '@luxuryescapes/contract-svc-agent'
import { agentHubCheckEmailStatusMapper } from './mappers/agentHubMap'
import qs from 'qs'
import { agentHubOrSubBrandConfig } from 'agentHub/constants'

type GetAgentStatusResponse = definitions['userStatusResponse']

async function requestGetAgentStatusByToken(token: string): Promise<App.AgentHubAgentStatusData> {
  const brand = agentHubOrSubBrandConfig.isCVFREnabled ? 'leagenthub_cvfr' : 'leagenthub'
  const query = qs.stringify({ brand })

  const response = await request.get<App.ApiResponse<GetAgentStatusResponse>>(`/api/agent/user/status/${token}?${query}`)

  return agentHubCheckEmailStatusMapper(response.result)
}

export default requestGetAgentStatusByToken
